import gButton from "@/components/g-button/g-button";
import gCard from "@/components/g-card/g-card.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import gForm from "@/components/g-form/g-form";
import gDataTable from "@/components/g-data-table/g-data-table";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import FiltroConsultarOrcamento from "@/shared/view-models/Filtros/FiltroConsultarOrcamento";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import OrcamentoInformacao from "./OrcamentoInformacao.vue";
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { defineComponent } from "vue";
import EVENTS from "@/shared/events/events";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import ConsultarOrcamentoPDF from './PDF/ConsultarOrcamentoPDF.vue';
import {mask} from 'vue-the-mask'


const name = 'ConsultarOrcamento'
export default defineComponent({
  name,
  directives: {mask},
  setup() {
    return {
      v$: useVuelidate()
    }
  },

  components: {
    'g-button': gButton,
    'g-card': gCard,
    'g-date-input': gDateInput,
    'g-form': gForm,
    'g-data-table': gDataTable,
    'g-pdf': gPdf,
    OrcamentoInformacao,
    Dashboard,
    ConsultarOrcamentoPDF,

  },

  props: { },

  validations() {
    /* eslint-disable */ 
    let data = {}
    let teste = {}
    if (this.motivoBaixa === 0 || this.motivoBaixa === 1) {
      data =  {
        required: helpers.withMessage('O campo de Concorrente é obrigatório', required)
       }
    }
    if (this.motivoBaixa === 0){
      teste = {
        required: helpers.withMessage('O campo de % é obrigatório', required)
      }
    }
    return {
      motivoBaixa: {
        required: helpers.withMessage('O campo de Motivo Baixa é obrigatório', required)
     },
     concorrenteId: data,
     porcentagem: teste
    }
  },

  mounted () {
    
    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.objFiltro.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.objFiltro.EmpresaId = this.$store.state.empresaSelecionadaId;
    });
    // this.objFiltro.EmpresaId = this.$store.state.empresaSelecionadaId;
    this.objFiltro.RepresentanteId = this.$store.state.representanteSelecionadoId;


    let urlParams = new URLSearchParams(window.location.search)
    if(urlParams.get('FlagDashboard') !== null){
      let myParam = parseInt(urlParams.get('status'))
      this.objFiltro.EmpresaId = this.$store.state.empresaSelecionadaId;
      this.objFiltro.Status = myParam;
      this.pt1 = false
      this.getOrcamentosByFiltro()
    }

    // this.getPermissaoReOrcamentos()




    this.EmpresaArray = this.$store.state.EmpresaArray;

    this.RepresentanteSelecionado = this.$store.state.representanteSelecionadoId;

    this.StatusArray = OrcamentoController.GetStatusOrcamentoEnum().StatusArray;
    this.getMotivoBaixa()
    this.getConcorrente()
    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.atualizaEmpresaRepresentante()
    })
    this.buscarLinhaProducao()
   },

  updated () { },

  data () {
    return {
      //arrayUnidade
      ConcorrenteArray: [],
      statusArrayFront: [
        { value: 20, text: "Todos" },
        { value: 0, text: "Todos em aberto na Empresa" },
        { value: 1, text: "Aguardando autorização Comercial" },
        { value: 2, text: "Em fila de espera" },
        { value: 3, text: "Em execução orçamento" },
        { value: 4, text: "Em definição departamento comercial" },
        { value: 5, text: "Aguardando Material" },
        { value: 6, text: "Em execução projeto" },
        { value: 7, text: "Aguardando retorno do vendedor" },
        { value: 8, text: "Aguardando solução pendência financeira" },
        { value: 9, text: "Aguardando definição de terceiros" },
        { value: 10, text: "Liberados para o vendedor" },
        { value: 11, text: "Baixado" },
        { value: 12, text: "Com o Cliente" },
        { value: 13, text: "Cancelado" },
        { value: 14, text: "Aguardando Consultor" },
        { value: 15, text: "Aguardando interno" },
        { value: 16, text: "Retornado ao vendedor" },
        { value: 17, text: "Respondido pelo vendedor" },
        { value: 18, text: "Pedido - Orçamento Válido" },
        { value: 19, text: "Aguardando Analista" }
      ],
      RepresentanteSelecionado: '',
      concorrenteId: null,
      ClienteSelecionado: null,
      porcentagem: null,
      EmpresaArray: [],
      EmpresaSelecionada: null,
      motivoBaixa: null,
      MotivoBaixaArray: [],
      orcamentoSelecionado: '',
      popupAviso: false,
      poupFaseCancelar: 0,
      renderiza: false,
      renderizadownload: false,
      formMotivoBaixa: {
        motivoBaixa: null,
        concorrenteId: null,
        orcamentoId: null,
        porcentagem: null
      },
      objFiltro: new FiltroConsultarOrcamento(),
      StatusArray: [],
      pt1: true,
      popup: false,
      popupReorcamento: false,
      popupOrcamentoQuantidade:false,
      checkboxConsultas: false,
      popupCancelarOrcamento: false,
      Id: null,
      LinhaProdutoSelecionada: null,
      linhaSelecionada: {},
      checkboxDoc: false,
      Copiavel: false,
      Colunas : [
        //Campo dos dados , nome que aparece na página
        {field: 'numeroSolicitacao', header: 'N° Solicitação', width: '80px', ordena: true},
        {field: 'dataDigitacaoFormatada', header: 'Dt. Digitação', width: '100px', ordena: true, ordenacao: 'dataDigitacao'},
        {field: 'dataAlteracaoFormatada', header: 'Dt. Retorno', width: '100px', ordena: true, ordenacao: 'dataDigitacao'},
        {field: 'nomeProduto', header: 'Nome Produto', width: '350px', ordena: true},
        {field: 'orcamentoSituacaoEnum', header: 'Status', width: '250px', ordena: true},
        {field: 'nomeRepresentante', header: 'Representante', width: '230px', ordena: true},
        {field: 'tipoText', header: 'Tipo', width: '260px', ordena: true},
        {field: 'empresaCliente', header: 'Empresa Cliente', width: '250px', ordena: true},
    ],
    Filtro: {
      'global': {value: null, matchMode: this.filtros.CONTAINS},
      'numeroSolicitacao': {value: null, matchMode:this.filtros.CONTAINS},
      'orcamentoSincronismoEnum': {value: null, matchMode: this.filtros.CONTAINS},
      'nomeProduto': {value: null, matchMode: this.filtros.CONTAINS},
      'orcamentoSituacaoEnum': {value: null, matchMode: this.filtros.CONTAINS},
      'nomeProdutoNovo': {value: null, matchMode: this.filtros.CONTAINS},
      'dataDigitacaoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
      'dataAlteracaoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
      'nomeEmpresa': {value: null, matchMode: this.filtros.CONTAINS},
      'nomeRepresentante': {value: null, matchMode: this.filtros.CONTAINS},
    },
    OrcamentoArray : [],
    TipoFluxoOrcamentoArray: [],
    LinhaProdutoArray : [],
    ProdutoArray: [],
    listaPermitidos: [],
    informacaoOrcamentoSelecionado:null,
    pdf: false,
    executar: 0,
    executarvisualizacao: 0,
    executardownload: 0,
    pdfvisualizacao: false,
    pdfdownload: false,
    nomeCliente:'',
    ProdutoNovoArray: null,
    timer: null,
    FlagDashboard: null,
    popupPedidoAtivo: false,
    codigoPedidoArray: [],
    totalOrcamentos: 0
     }
      // EhReorcavel: false

  },

  methods: {

    atualizaEmpresaRepresentante(){
      this.objFiltro.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },

    empresasSelecionadasContem(empresaId){
      return this.objFiltro.EmpresasIds.includes(empresaId)
    },

    copiarPopUp(linhaSelecionada){
      this.linhaSelecionada = linhaSelecionada
      this.popup = true;
    },

    copiarPopUpReorcamento(linhaSelecionada){
      this.linhaSelecionada = linhaSelecionada
      this.popupReorcamento = true;
    },

    copiarPopUpOrcamentoQuantidade(linhaSelecionada){
      this.linhaSelecionada = linhaSelecionada
      this.popupOrcamentoQuantidade = true;
    },

    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ClienteController.getClienteDropDownsByNome(event, this.objFiltro.EmpresaId, this.$store.state.representanteSelecionadoId).requisicao
        .then(res => {
          this.ClienteArray = res.data.data;
        });
      }, 1000);
    },


    criarCopiaDeOrcamento() {
      let tipoFluxoOrcamento = this.linhaSelecionada.tipoFluxoOrcamento

      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Orcamento/InsertNovoOrcamentoCopia/${this.linhaSelecionada.id}`,
        data:{
       }
      })
        .then((response) => {

         this.OrcamentoId = response.data.data
         this.tipoFluxoOrcamento = response.data.data

         switch(tipoFluxoOrcamento){
          case 0:
          this.$router.push(`/produto-novo/${this.OrcamentoId}/infos-cliente`)
          break

          case 1:
          this.$router.push(`/produto-repeticao/${this.OrcamentoId}/Informacao-Cliente-Repeticao`)
          break

          case 2:
          this.$router.push(`/produto-repeticao-alteracao/${this.OrcamentoId}/info-cliente-ra`)
          break
         }}
         )
      },

      fecharpopupPedidoAtivo (){
        this.popupPedidoAtivo = false
      },

      fecharpopupsair () {
        this.motivoBaixa = null
        this.concorrenteId = null
        this.poupFaseCancelar = 0
        this.popupAviso = false
        this.formMotivoBaixa.orcamentoId = null
        this.popupCancelarOrcamento = false
      },
      getMotivoBaixa () {
        /* eslint-disable */
        OrcamentoController.GetMotivoBaixa().requisicao
        .then((Response) => {
          this.MotivoBaixaArray = Response.data
        })
        .catch((Error) => console.error(Error))
      },
      getConcorrente () {
        OrcamentoController.GetConcorrentes().requisicao
        .then((Response) => {
        this.ConcorrenteArray = Response.data.data;
      })
      .catch((Error) => {
        console.error(Error);
      });
      },
      criarReorcamento() {
        let tipoFluxoOrcamento = this.linhaSelecionada.tipoFluxoOrcamento
        this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + `Orcamento/InsertReorcamento/${this.linhaSelecionada.id}?representanteId=${this.$store.state.representanteSelecionadoId}`,
          data:{
         }
        })
          .then((response) => {
           this.OrcamentoId = response.data.data
           switch(tipoFluxoOrcamento){
            case 0:
            this.$router.push(`/produto-novo/${this.OrcamentoId}/lote-frete`)
            break

            case 1:
            this.$router.push(`/produto-repeticao/${this.OrcamentoId}/Lote-Frete-Repeticao`)
            break

            case 2:
            this.$router.push(`/produto-repeticao-alteracao/${this.OrcamentoId}/lote-frete-ra`)
            break
           }}
           )
        },
        setMotivoBaixarOrcamento  () {
          if(this.v$.$invalid === false){
            this.formMotivoBaixa.concorrenteId = this.concorrenteId
            this.formMotivoBaixa.motivoBaixa = this.motivoBaixa
            this.formMotivoBaixa.percentualPerdaPreco = this.porcentagem
            this.$isLoading(true)
            OrcamentoController.SetMotivoBaixarOrcamento(this.formMotivoBaixa).requisicao
              .then((Response ) => {
                this.getOrcamentosByFiltro()
                this.fecharpopupsair()
                this.$isLoading(false)

              })
              .catch(() => {
              })
            } else {
              this.v$.$silentErrors.forEach(erro =>{
                this.$toast.add({severity:'error', summary: 'ERRO', detail:erro.$message,  life: 5000})

            })
            }

        },
    OpenModalCance(data) {
       /* eslint-disable */
      this.formMotivoBaixa.orcamentoId = data.id
      this.popupAviso = true
    },
    fecharpopupsair () {
      this.motivoBaixa = null
      this.concorrenteId = null
      this.poupFaseCancelar = 0
      this.popupAviso = false
      this.formMotivoBaixa.orcamentoId = null
      this.popupCancelarOrcamento = false
    },
    nextFase() {
      this.verificaPedidoAtivo()
    
    },

    fecharpopup(){
      this.popup=false
      this.popupReorcamento=false
      this.popupOrcamentoQuantidade=false
    },

    OrcamentoGetAtivos(){
      this.OrcamentoArray = OrcamentoController.getOrcamentosAtivos().OrcamentoArray

    },

    Grid () {
      this.getOrcamentosByFiltro()
    },

    getOrcamentosByFiltro(){
      this.$isLoading(true)
      OrcamentoController.getOrcamentosByFiltro(this.objFiltro).requisicao
      .then(res => {
        this.OrcamentoArray = res.data.data.data;
        this.totalOrcamentos = res.data.data.totalOrcamentos;
        
        this.pt1 = false;
        this.$isLoading(false);
        if(this.OrcamentoArray.length > 0)
        {
          this.getPermissaoReOrcamentos()
        }
      })
    },

    getPermissaoReOrcamentos(){

      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Orcamento/GetPermissaoReOrcamentos',
        data:  this.OrcamentoArray
      })
      .then((response) => {
        this.listaPermitidos = response.data.data.map((Element) => Element.id)
      })
    },

    routerInformacao(data){
      this.$router.push(`orcamento-informacao/${data.id}`)
    },
    getMotivoBaixa () {
      OrcamentoController.GetMotivoBaixa().requisicao
      .then((Response) => {
        this.MotivoBaixaArray = Response.data
      })
      .catch((Error) => console.error(Error))
    },
    getAllClientes () {
      ClienteController.getClientes().requisicao
        .then((Response) => {
          this.ClientesArray = Response.data
        })
        .catch((Error) => console.error(Error))
    },
    detalhesOrcamento(data){
      const rotaNovaAbaURL = this.$router.resolve({
        path: `orcamento-informacao/${data.id}`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank')
    },

    imprimir(data){
      if(this.orcamentoSelecionado === data.id){
        this.orcamentoSelecionado = '';
      }
      setTimeout(()=>{
        this.renderiza = true
        this.pdfvisualizacao = true
        this.pdfdownload = false
        this.orcamentoSelecionado = data.id
      })
    },

    download(data){
      this.nomeCliente = data.nomeFantasia
      if(this.orcamentoSelecionado === data.id){
        this.orcamentoSelecionado = '';
      }
      setTimeout(()=>{
        this.renderizadownload = true
        this.pdfvisualizacao = false
        this.orcamentoSelecionado = data.id
      })
    },

    gerarPdf(){
      this.generatePdf()
    },

    limparFiltro(){
      this.objFiltro = new FiltroConsultarOrcamento();
      this.orcamentoArray = []
      this.atualizaEmpresaRepresentante()
    },

    //popup de reorcamento

    redireciona(){

      this.criarCopiaDeOrcamento(this.informacaoOrcamentoSelecionado)
    },


    redirecionaReorcamento(){

      this.criarReorcamento(this.informacaoOrcamentoSelecionado)
    },

    redirecionaOrcamentoQuantidade(){

      this.criarOrcamentoQuantidade(this.informacaoOrcamentoSelecionado)
    },

    abrePopup (informacaoDaLinha) {
      this.popup = true
      this.informacaoOrcamentoSelecionado = informacaoDaLinha
    },

    abreQuantidade (informacaoDaLinha) {
      this.popup = true
      this.informacaoOrcamentoSelecionado = informacaoDaLinha
    },

    generatePdf() {
      this.executarvisualizacao++
    },

    downloadPdf() {
      this.executardownload++
    },

    buscarLinhaProducao(){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        OrcamentoController.getLinhaProducaoDropDownsByNome().requisicao
        .then(response => {
          this.LinhaProdutoArray = response.data.data
        })
      }, 1000);
    },

    getProdutoNovo(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoNovoByPesquisaRepresentante(pesquisa, this.$store.state.representanteSelecionadoId, this.objFiltro.EmpresaId).requisicao
        .then((res) => {
          this.ProdutoNovoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },

    getProduto(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoDropDownByPesquisaRepresentanteEmpresa(pesquisa, this.$store.state.representanteSelecionadoId, this.objFiltro.EmpresaId).requisicao
        .then((res) => {
          this.ProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },

    criarOrcamentoQuantidade() {
      let tipoFluxoOrcamento = this.linhaSelecionada.tipoFluxoOrcamento
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Orcamento/InsertOrcamentoQuantidade/${this.linhaSelecionada.id}?representanteId=${this.$store.state.representanteSelecionadoId}`,
        data:{
       }
      })
        .then((response) => {
         this.OrcamentoId = response.data.data
         this.tipoFluxoOrcamento = response.data.data
         switch(tipoFluxoOrcamento){
          case 0:
          this.$router.push(`/produto-novo/${this.OrcamentoId}/info-basicas`)
          break

          case 1:
          this.$router.push(`/produto-repeticao/${this.OrcamentoId}/info-basicas-repeticao`)
          break

          case 2:
          this.$router.push(`/produto-repeticao-alteracao/${this.OrcamentoId}/info-basicas-ra`)
          break
         }}
         )
      },
      limpaCampoPorcentagem (){
        this.porcentagem = null
      },

      verificaPedidoAtivo (){
        OrcamentoController.GetPedidoAtivo(this.formMotivoBaixa.orcamentoId).requisicao
        .then((response)=>{
          if(response.data.data === null) {
            this.popupAviso = false
            this.popupCancelarOrcamento = true
          } else {
            this.getCodigoPedido()
            this.popupAviso = false
            this.popupPedidoAtivo = true
          }
         

        })
      },
      getCodigoPedido (){
        OrcamentoController.GetCodigoPedido(this.formMotivoBaixa.orcamentoId).requisicao
        .then((response)=>{
          this.codigoPedidoArray = response.data.data
        })
      }
      // buscarClientes(event){

      //   window.clearTimeout(this.timer);
      //   this.timer = setTimeout(() => {
      //     this.ClienteArray = ClienteController.getClientes(event).ClientesArray;
      //   }, 1000);
      // },
  },

  computed: { },

});